import React from 'react';

class BlankPage extends React.Component {
    render() {
        return (
            <center><p>I think you're on the wrong page :0 if you were looking for the current version of cs17, you can find the website at www.cs.brown.edu/courses/cs017</p></center>
        );
    }
}

export default BlankPage;